import { translateRole } from "../../../translations";
const roles = [
  { id: 1, name: translateRole("EXECUTIVE_MANAGER") },
  { id: 2, name: translateRole("MANAGER") },
  { id: 3, name: translateRole("CHIEF") },
  { id: 4, name: translateRole("EMPLOYEE") },
];

const weekDays = [
  { id: 0, weekday: "Δευτέρα" },
  { id: 1, weekday: "Τρίτη" },
  { id: 2, weekday: "Τετάρτη" },
  { id: 3, weekday: "Πέμπτη" },
  { id: 4, weekday: "Παρασκευή" },
  { id: 5, weekday: "Σάββατο" },
  { id: 6, weekday: "Κυριακή" },
];
const weekDayOptionsMap = [
  { id: 1, weekday: "Δευτέρα" },
  { id: 2, weekday: "Τρίτη" },
  { id: 3, weekday: "Τετάρτη" },
  { id: 4, weekday: "Πέμπτη" },
  { id: 5, weekday: "Παρασκευή" },
  { id: 6, weekday: "Σάββατο" },
  { id: 7, weekday: "Κυριακή" },
];

const daysMap = {
  1: "Δευτέρα",
  2: "Τρίτη",
  3: "Τετάρτη",
  4: "Πέμπτη",
  5: "Παρασκευή",
  6: "Σάββατο",
  7: "Κυριακή"
};
export { roles, weekDays, daysMap, weekDayOptionsMap };
import session from "../../../api/session";

export function createUser(form) {
  const response = session.post("api/user/create/", {
    user: {
      username: form.user.username,
      first_name: form.user.firstName,
      last_name: form.user.lastName,
      email: form.user.email,
    },
    fathers_name: form.user.fathersName,
    mothers_name: form.user.mothersName,
    phone: form.user.phone,
    secondary_role: form.secondaryRole,
    department: form.departments.map((e) => e.departmentId),
    relationship: form.relationship.map((e) => e.relationship)[0],
    role: form.roles.map((e) => e.roleId)[0],
    hrms_person_id: form.hrmsPersonID,
  });

  return response;
}

export function createPersonDeviceIdentity(form) {
  const response = session.post("api/device-identity/create/", {
    person: form.user.username,
    card_number: form.card.map((e) => e.cardNumber).join(""),
    password: "",
    privilege: 0,
    device: form.devices,
  });

  return response;
}

export function createPersonWorkingSchedule(form) {
  form.schedule.forEach((element) => {
    const response = session.post("api/user/schedule/create/", {
      person: form.user.username,
      start_time: element.startTime,
      end_time: element.endTime,
      start_date: form.schedule.startDate,
      end_date: form.schedule.endDate,
      weekdays: form.schedule.weekdays,
    });
    return response;
  });
}

export function createPersonContract(form) {
  const response = session.post("api/contract/create/", {
    person: form.user.username,
    start_date: form.contract.contractStartDate,
    end_date: form.contract.contractEndDate,
    comments: form.contract.comment,
  });
  return response;
}
